module.exports = __webpack_public_path__ + "media/images/backgrounds/angle-top-right-outer-dark-9a5ebbb95e4230faca132a0e46f83e0b.svg";